import {
	insertDataToTicket,
	getObjectFromSessionStorage,
	hammerEventsHandler,
	convertStringToObject,
	updateAllSums,
	viewPromoButton,
} from "./utils";

const $ = window.jQuery;
const svgPanZoom = window.svgPanZoom;
const prices = window.prices;
const uniquePrices = window.uniquePrices;
const svg = $(".js-svg");
const eventId = svg.data("id");
const unitId = svg.data("unit");
const csrfToken = $("meta[name='csrf-token']").attr("content");
const isDesktop = window.matchMedia("(min-width: 768px)");
const placesPricesDom = $(".js-places-prices");

let isPlaces;
let placesPrices = [];
let previousHtml;
let panZoom;

const eventObject = {
	init() {
		eventObject.setUpListeners();
		eventObject.setCartItems();
		eventObject.addActionToPlace();

		if (svg.length) {

			if (isDesktop.matches) {
				eventObject.setPanZoom();
				if (isPlaces) {
					$(".places__prices").show();
					$(".places__info").show();
				} else {
					eventObject.addActionToSector();
				}
				eventObject.getPrices();
			} else {
				// if (isPlaces) {

				// } else {
				// 	eventObject.setTagsToSectorPlaces();
				// 	eventObject.addActionToSector();
				// }
			}
		}
	},
	setPanZoom: () => {
		const svgElement = document.querySelector("#svg-wrap svg");
		if (
			!$(svgElement)
				.parents(".places")
				.is(":visible")
		) {
			return false;
		}
		let isEnableZoom = true;

		if (isDesktop.matches) {
			isEnableZoom = false;
		}

		panZoom = svgPanZoom(svgElement, {
			zoomEnabled: true,
			mouseWheelZoomEnabled: isEnableZoom,
			dblClickZoomEnabled: false,
			customEventsHandler: hammerEventsHandler,
		});
		panZoom.fit();
		panZoom.zoom(0.75);
		panZoom.center();

		$(".js-svg-plan-zoom-in").on("click", () => {
			panZoom.zoomIn();
		});

		$(".js-svg-plan-zoom-out").on("click", () => {
			panZoom.zoomOut();
		});

		$(".js-svg-plan-reset").on("click", () => {
			panZoom.resetZoom();
			panZoom.resetPan();
			panZoom.zoom(0.75);
		});

		$(window).resize(() => {
			panZoom.resize();
			panZoom.fit();
			panZoom.zoom(0.75);
			panZoom.center();
		});

		return false;
	},

	setCartItems: () => {
		const cartCount = $(".js-count");
		$.ajax({
			url: "/event/cart/get-cart",
			data: {"_csrf-frontend": csrfToken},
			type: "POST",
			success: response => {
				const res = JSON.parse(response);
				$.each(res, (index, order) => {
					const countTickets = order.count_tickets;
					cartCount.text(countTickets).removeClass("inactive");

					if (eventId === order.sitting_id) {
						const promocodeValue = order.default_amount - order.amount;
						const eventSum = $(".js-sum");
						$.each(eventSum, (i, element) => {
							$(element).text(Number(order.amount + order.commission));
						});
						$(".js-promo-discount").text(`${order.default_amount - order.amount}`);
						$(".js-promocode-value").text(promocodeValue);
						$(".js-tickets-count").text(countTickets);
						$(".js-commission").text(order.commission);
						const buy = $(".places__buy");
						if (!buy.hasClass("js-places-buy")) {
							buy.addClass("js-places-buy");
							buy.data("selenium", "event_pay");
							buy.data("payment", order.id);
							buy.attr("href", `/pay/pay?id=${order.id}`);
						}
					}
				});
			},
			error: error => {
				console.error("Error ", error);
			},
		});
	},

	setActiveTickets: () => {
		const ticketsItems = $(".tickets__item");
		$.each(ticketsItems, (index, element) => {
			const place = $(element).data("place");
			const isPack = $(element).data("ispack");
			if (place && !isPack) {
				$(`#${place}`).addClass("yellow active");
				$(`#${place}`).data("available", "false");
			}
			if (isPack) {
				$(`#${place}`).data("ispack", "true");
			}
		});
	},

	setUpListeners: () => {
		$(document).on("click", ".js-places-buy", e => {
			if ($(".header__enter").hasClass("header__enter_quest")) {
				e.preventDefault();
				eventObject.getFastRegistration();
			}
		});

		$(document).on("click", ".js-promo .promo__button", e => {
			const element = $(e.target);
			const orderId = element.parents(".js-promo").data("order");
			const code = element
				.parents(".js-promo")
				.find(".promo__input")
				.val();
			eventObject.setPromocode(orderId, code);
			element.addClass("inactive")
		});

		$(document).on("click", ".js-places-open", e => {
			const element = $(e.currentTarget);
			const tickets = element.parents(".places").find(".js-tickets");
			const promo = element.parents(".places").find(".js-promo");
			$(promo).show();
			element.toggleClass("active");
			$(tickets).slideToggle("slow");
		});

		$(document).on("click", ".js-tickets-remove", e => {
			const element = e.currentTarget;
			const sid = $(element)
				.parents(".tickets__item")
				.data("place");
			const elementEventId = $(element)
				.parents(".tickets__item")
				.data("event");
			eventObject.removeFromCart(sid, elementEventId);
			$(`#${sid}`).data("available", "true");
		});

		if (window.location.pathname.includes("event") && !isDesktop.matches) {
			eventObject.getPopup();
		}

		$(".js-places-button").on("click", e => {
			const element = $(e.currentTarget);
			$(".js-places-button").removeClass("active");
			element.addClass("active");
		});

		$(document).on("click", ".js-places-back", e => {
			const element = $(e.currentTarget);
			element.hide();
			$(".js-change-svg").html(previousHtml);
			eventObject.setTagsToSectors();
			eventObject.getPrices();
			placesPricesDom.hide();
			panZoom.destroy();
			setTimeout(eventObject.setPanZoom, 200);
			isPlaces = false;
		});

		$(document).on("click", "#js-order-clear", () => {
			$.ajax({
				url: "/event/cart/remove-full",
				type: "POST",
				success: () => {
					window.location.reload();
				},
			});
		});
	},

	setTagsToSectors: pricesCurrent => {
		placesPrices = [];
		$.each(pricesCurrent, (index, element) => {
			const id = element.id;
			const name = element.name;
			const price = element.price;
			const color = element.color;
			const zone = element.z;
			const selector = $(`#${id}`);
			selector.data("available", "true");
			selector.data("name", name);
			selector.data("zone", zone);
			selector.data("price", price);
			placesPrices.push(`price:${price},color:${color},zone:${zone}`);
			selector.find("rect").css("fill", color);
			selector.find("ellipse").css("fill", color);
			selector.find("circle").css("fill", color);
			selector.addClass("active");
		});
		const elements = $(".js-svg g[mode]");

		$.each(elements, (index, element) => {
			if (!$(element).hasClass("active")) {
				if (Number($(element).attr("mode")) !== 1) {
					$(element).addClass("disabled");
				}
				if (Number($(element).attr("mode")) === 2) {
					if (!isPlaces) {
						$(element).addClass("active");
					}
				}
			}
		});
	},

	setTagsToSectorPlaces: () => {
		const sectors = svg.find("g");
		isPlaces = true;
		$.each(sectors, (index, sector) => {
			if (Number($(sector).attr("mode")) === 1) {
				isPlaces = false;
				$(sector).attr("view", $(sector).attr("view_id"));
				$(sector).attr("sector-name", $(sector).attr("view_id"));
				$(sector).attr("sector-id", $(sector).attr("view_id"));
				$(sector).attr("all", $(sector).attr("count"));
				$(sector).attr("data-type", "standart");
			}
		});
	},

	setPromocode: (order_id, code) => {
		$.ajax({
			url: "/promo/apply",
			data: {order_id, code},
			type: "POST",
			beforeSend: () => {
				$(".js-places-overlay").show();
			},
			success: response => {
				const res = JSON.parse(response);
				const parent = $(`.js-promo[data-order=${order_id}]`).closest(".js-order");
				if (res.status) {
					parent.find(".js-promo").find(".promo__button").addClass("active").text("Успешно");
					parent.find(".promo__discount").addClass("active");
					parent.find(".promo__wrapper").css("pointer-events", "none");
					let sale = 0;
					let commission = 0;
					for (let i = 0; i < res.carts.length; i++) {
						sale += res.carts[i].discount;
						commission += res.carts[i].commission;
						const ticket = $(`.tickets__item[data-id="${res.carts[i].id}"]`);
						ticket.find(".js-ticket-price").text(res.carts[i].price);
					}

					parent.find(".js-sum").html(res.summ);
					parent.find(".js-promo-discount").html(sale);
					parent.find(".js-promo-commission").html(commission);
					parent.find(".promo__button").attr("disabled", "true");
					parent.find(".js-promo").find(".promo__message").hide();
					parent.find(".promo__input").val(code).attr("disabled", true);
				} else {
					const message = res.msg;
					$(".js-promo")
						.find(".promo__message")
						.addClass("error")
						.text(message);
				}
			},
			complete: () => {
				$(".js-places-overlay").hide();
				$(".promo__button").removeClass("inactive");
			},
			error: error => {
				console.error("Error ", error);
			},
		});
	},

	setPlacesPrices: () => {
		placesPricesDom.html("");

		placesPrices = Array.from(new Set(placesPrices));

		placesPrices = placesPrices.map(item => {
			return convertStringToObject(item);
		});

		placesPrices = placesPrices.sort((a, b) => {
			return a.price - b.price;
		});

		for (let i = 0; i < placesPrices.length; i++) {
			const item = placesPrices[i];
			const placesPrice = `<label   class="places__price">
<input class="places__input" type="checkbox" data-color="${item.color}" data-zone="${item.zone}">
<span class="places__price-content"><span class="places__price-color" style="background-color: ${item.color} "></span>
<span>${item.price} ₽</span></span>
</label>`;
			placesPricesDom.append(placesPrice);
		}

		eventObject.addActionToPrice();
	},

	getPrices: (view_id = 0) => {
		$.ajax({
			url: "/event/get-prices",
			data: {event_id: eventId, view_id, "_csrf-frontend": csrfToken},
			type: "POST",
			beforeSend: () => {
				$(".js-places-overlay").show();
			},
			success: response => {
				const res = JSON.parse(response);
				if (isPlaces) {
					eventObject.setTagsToSectors(res.prices);
					eventObject.setPlacesPrices();
				} else {
					eventObject.addPricesPlacesToSector();
					eventObject.addPricesToSector();
					eventObject.addActionToPriceSector();
				}

				eventObject.setActiveTickets();
			},
			error: error => {
				console.error("Error ", error);
			},
			complete: () => {
				$(".js-places-change").addClass("active");
				$(".js-places-overlay").hide();
			},
		});
	},

	getSectorSvg: viewId => {
		$.ajax({
			url: "/event/get-svg",
			data: {event_id: eventId, view_id: viewId, "_csrf-frontend": csrfToken},
			type: "POST",
			beforeSend: () => {
				$(".js-places-overlay").show();
			},
			success: response => {
				const res = JSON.parse(response);
				$(".js-change-svg").html(res.svg);
				eventObject.getPrices(viewId);
				eventObject.setPanZoom();
				$(".places__prices").show();
				try {
					localStorage.setItem(`${unitId}_${viewId}`, res.svg);
				} catch (e) {
					console.error(e.message);
				}

			},
			complete: () => {
				$(".js-places-overlay").hide();
			},
			error: error => {
				console.error("Error ", error);
			},
		});
	},

	getFastRegistration: () => {
		$("#fastRegisterModal")
			.detach()
			.appendTo("body");
		$("#fastRegisterModal").modal();
	},

	getPopup: () => {
		$("#js-popup-modal").addClass("modal_event");
		$("#js-popup-modal .modal-body").append($(".places"));
		$("#js-popup-modal .places").show();
		$(".places__top").show();
		if (isPlaces) {
			$(".places__prices").show();
			$(".places__info").show();
		}
		$(".modal-body .places__cart").prepend($(".modal-body .places__info"));
		$(".modal-body .places__cart").prepend($(".modal-body .places__prices"));
		// $(".modal-body .places__cart").append($(".modal-body .js-promo"));
		$(".modal-body .places__cart").append($(".modal-body .js-event-places-right"));
		$(".modal-body .js-event-places-right").removeClass("hide");
		$(".js-tickets").hide();
		$("#js-popup-modal").modal();
		viewPromoButton();
		setTimeout(eventObject.getPrices, 200);
		setTimeout(eventObject.setPanZoom, 200);
		if (isPlaces) {
			setTimeout(eventObject.addActionToPlace, 200);
		} else {
			setTimeout(eventObject.setTagsToSectorPlaces, 200);
			setTimeout(eventObject.addActionToSector, 200);
		}
		setTimeout(eventObject.setActiveTickets, 200);
	},

	addToCart: sid => {
		$.ajax({
			url: "/event/cart/add",
			data: {event_id: eventId, sid, "_csrf-frontend": csrfToken},
			type: "POST",
			beforeSend: () => {
				$(".js-places-overlay").show();
			},
			success: response => {
				const res = JSON.parse(response);
				if (res.carts) {
					for (let i = 0; i < res.carts.length; i++) {
						const item = res.carts[i];
						const isPack = res.carts[i].is_pack;
						if (!isPack) {
							$(`#${item.sid}`).addClass("yellow");
						} else {
							$(`#${item.sid}`).data("ispack", true);
						}
						const ticket = insertDataToTicket(item, isPack);
						updateAllSums(item);
						$(".tickets_event .js-tickets-items").append(ticket);
					}
					$(".js-count").each((index, element) => {
						$(element).text(Number($(element).text()) + 1);
					});
					$(".js-sum").text(res.order.amount)
					$(".js-event-places-right").show();
					$(".js-promo").show();
					$(".js-promo").data("order", res.order.id);
					$(".places__common")
						.addClass("active")
						.removeClass("short");
					$(".places__svg")
						.addClass("short")
						.removeClass("long");
					$(".js-places-selected").text(res.order.count_tickets);
					$(".places__cost").addClass("show");
					$(".places__bottom").removeClass("hide");

					const buy = $(".places__buy");
					if (!buy.data("payment")) {
						buy.data("payment", res.order.id);
						let type = "service";
						if (res.order.type_id === 0) {
							type = "event";
						}
						buy.addClass("js-places-buy")
						buy.data("order-id", res.order.id);
						buy.attr("href", `/pay/pay?id=${res.order.id}`);
						buy.data("type", type);
					}
				}

				if (res.redraw) {
					$(`#${sid}`).addClass("yellow");
					window.location.reload();
				}

				if (res.limit) {
					alert("Вы превысили максимально допустимое количество мест для брони");
				} else {
					for (let i = 0; i < res.carts.length; i++) {
						const item = res.carts[i];
						const isPack = res.carts[i].is_pack;
						if (!isPack) {
							$(`#${item.sid}`).addClass("yellow");
						}
					}

					eventObject.setCartItems();
				}
			},
			complete: () => {
				$(".js-places-overlay").hide();
			},
			error: error => {
				console.error("Error ", error);
			},
		});
	},

	removeFromCart: (sid, event_id = eventId) => {
		$.ajax({
			url: "/event/cart/remove",
			data: {event_id, sid, "_csrf-frontend": csrfToken},
			type: "DELETE",
			beforeSend: () => {
				$(".js-places-overlay").show();
			},
			success: response => {
				const res = JSON.parse(response);
				if (response.error) {
					window.location.reload();
				}
				if (res.redraw) {
					alert("Данное место больше недоступно. Выберите другое. ");
				}
				const carts = res.carts;

				if (carts.length > 1) {
					for (let i = 0; i < carts.length; i++) {
						const currentSid = carts[i].sid;
						$(`#${currentSid}`).removeClass("yellow");

						$(`.tickets__item[data-place='${currentSid}']`).remove();
					}
				} else {
					const uid = carts[0].uid;
					$(`.tickets__item[data-uid='${uid}']`).remove();
					$(`#${sid}`).removeClass("yellow");
				}

				$.each($(".js-sum"), (index, el) => {
					$(el).text(res.summ);
				});

				$(".js-count").each((index, el) => {
					$(el).text(res.count);
				});
				$(".js-places-selected").text(res.count);
				eventObject.setCartItems();

				if ($(".order").length && !$(".js-tickets-items").children().length > 0) {
					window.location.reload();
				}
				if (!$(".js-tickets-items").children().length > 0) {
					$(".js-event-places-right").addClass("hide");
					$(".places__cost")
						.addClass("hide")
						.removeClass("show");
					$(".modal-body .js-promo").hide();
					$(".places__common")
						.removeClass("active")
						.addClass("short");
					$(".places__svg")
						.removeClass("short")
						.addClass("long");
				}
			},
			complete: () => {
				$(".js-places-overlay").hide();
			},
			error: error => {
				console.error("Error ", error);
			},
		});
	},

	addActionToPlace: () => {
		$(document).on("click", e => {
			const element = e.target;
			if ($(element).closest("g.active").length) {
				const activeSector = $(element).closest("g.active");
				const sid = $(activeSector).attr("id");
				const isPack = $(activeSector).data("ispack");
				if (isPack) {
					$(activeSector).data("available", true);
				}
				const isCart = $(activeSector).data("available");
				if (isCart === "true") {
					if (!isPack) {
						$(activeSector).data("available", "false");
					}
					eventObject.addToCart(sid);
				} else if (isCart === "false") {
					$(activeSector).data("available", "true");
					eventObject.removeFromCart(sid);
				}

				if (isCart && isPack) {
					eventObject.addToCart(sid);
				}
			}
		});
		if (isDesktop.matches) {
			$(document).on("mouseover", e => {
				const element = $(e.target);
				if (element.closest("g.active").length) {
					const activeSector = $(element).closest("g.active");
					const name = activeSector.data("name");
					const price = activeSector.data("price");
					eventObject.addTooltipToPlace(activeSector, price, name);
				} else {
					$(".tooltip-info").hide();
				}
				if (element.closest("g[view_id]").length) {
					const activeSector = $(element).closest("g[view_id]");
					let name = activeSector.find("text").text();
					if (!name) {
						name = activeSector.next().text();
					}
					const price = activeSector.attr("price");
					const count = activeSector.attr("count");
					const free = activeSector.attr("free");

					eventObject.addTooltipToSector(activeSector, price, count, free, name);
				}
			});
		}
	},

	addActionToPrice: () => {
		$(".places__price input").change(e => {
			const input = $(e.currentTarget);
			if (input.is(":checked")) {
				const color = input.data("color");
				input.next().css("border-color", color);
			}
			if ($(".places__price input:checked").length === 0) {
				$("g.active").removeClass("gray");
			} else {
				$("g.active").each((i, elem) => {
					const el = $(elem);
					const myPriceStr = String(el.data("zone"));
					if (myPriceStr) {
						const myPrice = myPriceStr.split(",");
						let hideFlag = 0;

						for (let j = 0; j < myPrice.length; j++) {
							if (!$(`input[data-zone="${parseInt(myPrice[j])}"]`).is(":checked")) {
								hideFlag++;
							}
						}
						if (hideFlag === myPrice.length) {
							el.addClass("gray");
						} else {
							el.removeClass("gray");
						}
					}
				});
			}
		});
		$(".places__price").hover(
			e => {
				const color = $(e.currentTarget)
					.find(".places__price-color")
					.css("background-color");
				$(e.currentTarget)
					.find(".places__price-content")
					.css("border-color", color);
			},
			e => {
				const input = $(e.currentTarget).find("input");
				if (input.is(":checked")) {
					$(e.currentTarget)
						.find(".places__price-content")
						.css("border-color", input.data("color"));
				} else {
					$(e.currentTarget)
						.find(".places__price-content")
						.css("border-color", "transparent");
				}
			},
		);

		$(".places__price").on("click", e => {
			const element = $(e.currentTarget);
			if (element.find(".places__price-content").css("border-color") !== "transparent") {
				element.find(".places__price-content").css("border-color", "transparent");
			}
		});
	},

	addActionToPriceSector: () => {
		$(".places__price input").change(e => {
			const input = $(e.currentTarget);
			if (input.is(":checked")) {
				input.next().css("border-color", "#e01115");
			} else {
				input.next().css("border-color", "transparent");
			}
			if ($(".places__price input:checked").length === 0) {
				$("g[view_id]").removeClass("inactive");
			} else {
				$("g[view_id]").each((i, elem) => {
					const el = $(elem);
					const myPriceStr = String(el.attr("price"));
					if (myPriceStr) {
						const myPrice = myPriceStr.split(",");
						let hideFlag = 0;

						for (let j = 0; j < myPrice.length; j++) {
							if (!$(`input[data-price="${parseInt(myPrice[j])}"]`).is(":checked")) {
								hideFlag++;
							}
						}
						if (hideFlag === myPrice.length) {
							el.addClass("inactive");
						} else {
							el.removeClass("inactive");
						}
					}
				});
			}
		});
	},

	addPricesToSector: () => {
		for (let i = 0; i < prices.length; i++) {
			const item = prices[i];
			const viewId = item.viewId;
			const price = item.price;
			const element = $(`g[view_id='${viewId}'`);
			if (!element.attr("price")) {
				element.attr("price", price);
			} else {
				let strPrice = element.attr("price");
				strPrice += `,${price}`;
				element.attr("price", strPrice);
			}
		}
	},

	addPricesPlacesToSector: () => {
		for (const prop in uniquePrices) {
			if (Object.prototype.hasOwnProperty.call(uniquePrices, prop)) {
				if (uniquePrices[prop] !== null) {
					placesPrices.push(Number(uniquePrices[prop]));
				}
			}
		}

		placesPricesDom.html("");
		placesPrices = placesPrices.sort((a, b) => {
			return a - b;
		});
		for (let i = 0; i < placesPrices.length; i++) {
			const item = placesPrices[i];
			const placesPrice = `<label class="places__price">
<input class="places__input" type="checkbox" data-price="${item}">
<span class="places__price-content">
<span>${item} ₽</span></span>
</label>`;
			placesPricesDom.append(placesPrice);
		}
		placesPricesDom.addClass("places__prices_sector");
		placesPricesDom.show();
	},

	addActionToSector: () => {
		$(".js-places-change").addClass("active");
		previousHtml = $(".js-change-svg").html();
		$(document).on("click", e => {
			const element = e.target;
			if ($(element).closest("g[view_id]").length) {
				const activeSector = $(element).closest("g[view_id]");
				const sectorId = activeSector.attr("view_id");
				const svgLocal = localStorage.getItem(`${unitId}_${sectorId}`);
				if (!svgLocal) {
					eventObject.getSectorSvg(sectorId);
				} else {
					$(".js-change-svg").html(svgLocal);
					eventObject.getPrices(sectorId);
					$(".places__prices").show();
					$(".places__info").show();
				}
				panZoom.destroy();
				setTimeout(eventObject.setPanZoom, 200);
				$(".js-places-back").show();
				isPlaces = true;
			}
		});
	},

	addTooltipToPlace: (activeSector, price, name) => {
		const info = $(".js-seat-info");
		const clientX =
			activeSector[0].getBoundingClientRect().x ||
			activeSector[0].getBoundingClientRect().left;
		const clientY =
			activeSector[0].getBoundingClientRect().y ||
			activeSector[0].getBoundingClientRect().top;
		const y = clientY - info.outerHeight();
		const x = clientX - info.outerWidth() / 2;
		if (price) {
			info.find(".tooltip-info__price").text(`${price} ₽`);
			info.find(".tooltip-info__name").text(name);
			info.css({left: x, top: y});
			info.show();
		}
	},

	addTooltipToSector: (activeSector, price, count, free, name) => {
		const info = $(".js-sector-info");
		const clientX =
			activeSector[0].getBoundingClientRect().x ||
			activeSector[0].getBoundingClientRect().left;
		const clientY =
			activeSector[0].getBoundingClientRect().y ||
			activeSector[0].getBoundingClientRect().top;
		const y = clientY - info.outerHeight();
		const x = clientX - info.outerWidth() / 2;
		if (price && price.length > 1) {
			price = price.split(",");
			price = price.sort((a, b) => {
				return a - b;
			});
		}
		if (price) {
			price = Array.from(price).map(item => {
				return ` ${item} ₽`;
			});
		}

		info.find(".tooltip-info__price").text(`Цена ${price}`);
		info.find(".tooltip-info__name").text(`Сектор ${name}`);
		info.find(".tooltip-info__available").text(`Свободно ${free}`);
		info.find(".tooltip-info__count").text(`из ${count}`);
		info.css({left: x, top: y});
		info.show();
	},
};

export default eventObject;
